import React from 'react';
import { X } from '@finect/tabular-icons/x';
import { CountChipBlock } from './partials';
export var CountChip = function CountChip(_ref) {
  var value = _ref.value,
    onAction = _ref.onAction;
  var handleAction = function handleAction() {
    onAction && onAction();
  };
  return React.createElement(CountChipBlock, {
    onClick: handleAction,
    withClose: Boolean(onAction)
  }, React.createElement("span", null, value), onAction ? React.createElement("span", null, React.createElement(X, null)) : null);
};